import React, { useRef, useState, useLayoutEffect } from 'react'
import classnames from 'classnames'

const DraggableWindow = (props) => {
  const [pressed, setPressed] = useState(false)
  const [position, setPosition] = useState({x: props.position.x, y: props.position.y})
  const ref = useRef()

  // Monitor changes to position state and update DOM
  useLayoutEffect(() => {
    if (ref.current) {
      ref.current.style.transform = `translate(${position.x}px, ${position.y}px) translate(${props.offset})`
    }
  }, [position])

  // Update the current position if mouse is down
  const onMouseMove = (event) => pressed && props.dragable && setPosition({ x: position.x + event.movementX, y: position.y + event.movementY });

  return (
    <div id={props.id} className={classnames(props.className, {'dragging':pressed})} ref={ref}
      onMouseMove={onMouseMove} onMouseDown={(e) => {setPressed(true); e.preventDefault();}}
      onMouseUp={(e) => {setPressed(false); e.preventDefault();}} onMouseLeave={() => setPressed(false)}
      >
      {props.children}
    </div>
  )
}

export default DraggableWindow